import "./Card.css";

export default function Card() {
  	return (
        <div className="col-md-6 col-xxl-4 mb-6">
            <div className="card h-100">
                <div className="card-header d-flex align-items-center justify-content-between">
                    <h5 className="card-title m-0 me-2">Sezione Uno</h5>
                </div>
            </div>
        </div>
	);
}